import NavHeader from "./NavHeader";
import styles from "./hiw.module.css";
import Footer from "../shared/Footer";

const HIW = () => {
    return (
        <>
        <NavHeader />
        <div className={styles.hiw}>
            <h2 className={styles.title}>How It Works</h2>
            <div className={styles.steps}>
                <div className={styles.step}>
                    <div className={styles.icon}>1</div>
                    <h3 className={styles.stepTitle}>Sign Up</h3>
                    <p className={styles.stepDesc}>Create your account and set up your profile to get started.</p>
                </div>
                <div className={styles.step}>
                    <div className={styles.icon}>2</div>
                    <h3 className={styles.stepTitle}>Enter Skills/Chapters/Topics</h3>
                    <p className={styles.stepDesc}>
                        <b>Search by Learn/Teach Page</b><br/>
                        Go to Learn/Teach in Navigation Bar<br/>
                         Enter skills, chapters, or topics You want to Learn<br/>
                         Enter skills, chapters, or topics You want to Teach<br/>
                         Set Language <br/>
                         Click 'Search'<br/>
                        <br/>
                         OR<br/><br/>
                        <b>Search by Learn/Teach Lists</b><br/>

                        Navigate to Profile and manage your teaching and learning lists<br/>
                        Navigate to Learn/Teach page in Navigation Bar<br/>
                        Simply Click on 'Search by Lists'<br/>
                        This Matches with your partner if atleast one pair of complementary skills, chapters, or topics match. <br/>
                        For example, if you want to Learn 'Calculus' and Teach 'Physics',<br/>
                         and another user wants to Learn 'Physics' and Teach 'Calculus', you will be matched together.<br/>

                         </p>
                </div>
                <div className={styles.step}>
                    <div className={styles.icon}>3</div>
                    <h3 className={styles.stepTitle}>Start Learning</h3>
                    <p className={styles.stepDesc}> Find the perfect match for your learning needs. <br/>
                        Schedule sessions, communicate with your connection, and start your learning journey.</p>
                </div>
                <div className={styles.step}>
                    <div className={styles.icon}>4</div>
                    <h3 className={styles.stepTitle}>Achieve Your Goals</h3>
                    <p className={styles.stepDesc}>Learn New Things, Clear all Doubts, Cover  Missed Topics.<br/>
                         Even Gain Skills if you are in college, or Looking for learning new skills in any phase of Life. </p>
                </div>
                <div className={styles.step}>
                    <div className={styles.icon}>&nbsp;*&nbsp;</div>
                    <h3 className={styles.stepTitle}>Connecting With Peers' in Your School, College, Coaching Classes; And Even Your Town</h3>
                    <p className={styles.stepDesc}>Maintain the Schools College, Coaching Classe in My School in Home Page . <br/>
                        Set up Your city In The home page.<br/>
                        Find Peers in Your class, Other Sections and even Other Schools in the Town.
                    </p>
                </div>
                <div className={styles.step}>
                    <div className={styles.icon}>&nbsp;*&nbsp;</div>
                    <h3 className={styles.stepTitle}>Connecting Through Groups/Clubs/Channels</h3>
                    <p className={styles.stepDesc}> 
                        Navigate to 'Social' in the Navigation Bar<br/>
                        Select Group/Club/Channel <br/>
                        Find Group/Club/Channel and go to them.<br/>
                        Use Advanced Filters to find out the right Mate.
                    </p>
                </div>
                <div className={styles.step}>
                    <div className={styles.icon}>&nbsp;*&nbsp;</div>
                    <h3 className={styles.stepTitle}>Service</h3>
                    <p className={styles.stepDesc}> <br/>
                        <br/>
                        Comming Soon...
                    </p>
                </div>
                <div className={styles.step}>
                    <div className={styles.icon}>&nbsp;*&nbsp;</div>
                    <h3 className={styles.stepTitle}>Startups</h3>
                    <p className={styles.stepDesc}><br/>
                       <br/>
                        Comming...
                    </p>
                </div>
            </div>
        </div>
        <Footer />
        </>
    );
};
export default HIW;